import { Box, Button, Grid, Typography } from '@mui/material';

import React from 'react';
import { UNIT_CATEGORIES } from '../constants/units';
import { useTranslation } from 'react-i18next';

const CATEGORY_ICONS = {
  length: '📏',
  mass: '⚖️',
  force: '💪',
  energy: '⚡',
  power: '🔋',
  pressure: '🎇',
  temperature: '🌡️',
  time: '⏰',
  volume: '🧪',
  angle: '📐',
  area: '🟦',
};

function CategorySelector({ selectedCategory, onSelectCategory }) {
  const { t } = useTranslation();

  return (
    <Box sx={{ mb: 5 }}>
      <Typography
        variant="h5"
        align="center"
        sx={{
          mb: 3,
          color: 'white',
          fontWeight: 600,
          fontSize: { xs: '1.25rem', md: '1.5rem' },
        }}
      >
        {t('selectCategory')}
      </Typography>
      <Grid container spacing={{ xs: 1, sm: 2 }} justifyContent="center">
        {Object.values(UNIT_CATEGORIES).map(category => (
          <Grid item xs={6} sm={4} md={3} lg={2} key={category}>
            <Button
              fullWidth
              variant={selectedCategory === category ? 'contained' : 'outlined'}
              onClick={() => onSelectCategory(category)}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                py: { xs: 2, sm: 2.5 },
                px: { xs: 1, sm: 2 },
                bgcolor: selectedCategory === category ? 'primary.main' : 'white',
                color: selectedCategory === category ? 'white' : '#555',
                border: '2px solid',
                borderColor: selectedCategory === category ? 'primary.main' : '#e0e0e0',
                borderRadius: 3,
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-3px)',
                  boxShadow:
                    selectedCategory === category
                      ? '0 6px 20px rgba(102, 126, 234, 0.4)'
                      : '0 6px 20px rgba(102, 126, 234, 0.15)',
                  borderColor: 'primary.main',
                  bgcolor: selectedCategory === category ? 'primary.dark' : 'white',
                },
              }}
            >
              <Typography sx={{ fontSize: { xs: '1.75rem', sm: '2rem' } }}>{CATEGORY_ICONS[category]}</Typography>
              <Typography
                sx={{
                  fontSize: { xs: '0.75rem', sm: '0.875rem' },
                  fontWeight: 500,
                  textTransform: 'none',
                }}
              >
                {t(`categories.${category}`)}
              </Typography>
            </Button>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default CategorySelector;
